// Labels and badge colours for the admin Courses page (pages/admin/
// AdminCourseDashboard.jsx). Tones map to `.acm-badge--<tone>` in AdminCourses.css.

// Used until GET /api/v2/lms/admin/courses/categories answers (or if it fails).
export const BUILT_IN_CATEGORIES = [
  { name: 'Spoken English', icon: '📘', builtIn: true },
  { name: 'Computer Apps', icon: '💻', builtIn: true },
  { name: 'Life Skills', icon: '💡', builtIn: true },
  { name: 'Art', icon: '🎨', builtIn: true },
];

const BUILT_IN_CATEGORY_TONES = {
  'Spoken English': 'pink',
  'Computer Apps': 'blue',
  'Life Skills': 'amber',
  Art: 'rose',
};
const CUSTOM_CATEGORY_TONES = ['purple', 'sky', 'teal', 'indigo', 'lime', 'orange'];

export function categoryTone(name) {
  if (!name) return 'gray';
  if (BUILT_IN_CATEGORY_TONES[name]) return BUILT_IN_CATEGORY_TONES[name];
  let hash = 0;
  for (const char of name) hash = (hash * 31 + char.codePointAt(0)) % 9973;
  return CUSTOM_CATEGORY_TONES[hash % CUSTOM_CATEGORY_TONES.length];
}

export const DIFFICULTY_LEVELS = ['Beginner', 'Intermediate', 'Advanced'];
export const DIFFICULTY_TONES = { Beginner: 'green', Intermediate: 'orange', Advanced: 'red' };

export const COURSE_STATUSES = [
  { value: 'published', label: 'Published', tone: 'green' },
  { value: 'draft', label: 'Draft', tone: 'amber' },
  { value: 'archived', label: 'Archived', tone: 'gray' },
];

export function statusInfo(status) {
  return COURSE_STATUSES.find((entry) => entry.value === status) || COURSE_STATUSES[1];
}

// Whole-number share of `total`, 0 when there is nothing to divide by.
export function percentOf(count, total) {
  return total > 0 ? Math.round((count / total) * 100) : 0;
}

// Search box text against the course name, description and category.
export function matchesCourseSearch(course, search) {
  const term = search.trim().toLowerCase();
  if (!term) return true;
  return [course.title, course.description, course.category].some((value) =>
    (value || '').toLowerCase().includes(term)
  );
}
